module.exports = __webpack_public_path__ + "static/img/success12.f50c3d88.png";